import { PeriodsAgo, TeamMember } from "../../../../@types/custom";
import { db, firebase } from "firebaseConfig";
import { PERIODS_AGO_MAP } from "utils/dates";
import { hashIdentifiedFirestorePromisesWithArray, sleep } from "utils/Haim/utils";
import { parsePhoneNumber } from "utils/Haim/phoneNumbersUtils";
import { getCallsOfUser } from "utils/Haim/webotDataHelpers";
import type { DateRangeFilter } from "utils/listings/table";
import { CallSummary } from "../../../../@types/sharedSchema";

export async function getCalls(
  myTeamData: TeamMember[],
  selectedPeriod: PeriodsAgo | DateRangeFilter,
  fromPhoneNumber?: string
): Promise<Record<string, CallSummary[]>> {
  let result: Record<string, any> = {};

  if (myTeamData.length === 0) {
    return result;
  }

  const callsDataPromises = [];

  const forPeriod =
    typeof selectedPeriod === "object" ? selectedPeriod : PERIODS_AGO_MAP[selectedPeriod];

  for (let member of myTeamData) {
    const promise = getCallsOfUser(member.email, forPeriod, member.virtualNumbers, fromPhoneNumber);
    await sleep(100);
    callsDataPromises.push(promise);
  }

  const callsPerMember = await Promise.all(callsDataPromises);
  const allCallsCount = callsPerMember.reduce((acc, calls) => acc + calls.length, 0);
  console.log("allCallsCount: ", allCallsCount);
  for (let i = 0; i < myTeamData.length; i++) {
    const teamMemberMail = myTeamData[i].email;
    const callsData = callsPerMember[i].map((call) => ({
      ...call,
      _metadata: {
        id: `${teamMemberMail}|${call.id}|${call.virtualNumber}`,
        owner: { ...myTeamData[i], number: call.virtualNumber },
        firestorePath: `payCall-settings/${call.virtualNumber}/calls-summary/${call.id}`,
        callerPhoneNumber: parsePhoneNumber(call.callerNumberInternational)
      }
    }));
    // split callsData by virtual number
    const callsDataByVirtualNumber = callsData.reduce((acc, call) => {
      const virtualNumber = call.virtualNumber;
      if (!acc[virtualNumber]) {
        acc[virtualNumber] = [];
      }
      acc[virtualNumber].push(call);
      return acc;
    }, {});

    // building object expected by ui
    Object.keys(callsDataByVirtualNumber).forEach((virtualNumber) => {
      result[`${teamMemberMail}|${virtualNumber}`] = callsDataByVirtualNumber[virtualNumber];
    });
  }

  return result;
}
